import React from 'react';
import { Props } from './types';
import { Button } from '../Button';
import { i18n } from '../../i18n/translate';
import { sanitizeUrl } from '@braintree/sanitize-url';

// @ts-ignore
import GeneralErrorImg from '../../images/general_error.svg';
// @ts-ignore
import NotFoundImg from '../../images/not_found.svg';
// @ts-ignore
import NoAccessImg from '../../images/no_access.svg';
// @ts-ignore
import MaintenanceImg from '../../images/maintenance.svg';

export class ErrorPage extends React.Component<Props> {
  renderErrorMessages = () => {
    if (!Array.isArray(this.props.errors)) {
      return null;
    }
    return (
      <ul className="errors">
        {this.props.errors.map((error, index) => {
          if (typeof error === 'string' || React.isValidElement(error)) {
            return (
              <li key={`error[${index}]`} className="error-message">
                {error}
              </li>
            );
          } else {
            return null;
          }
        })}
      </ul>
    );
  };

  renderTechnicalContact = () => {
    if (!this.props.techContact) return null;

    const {
      technical_contact_name: name,
      technical_contact_phone: phone,
      technical_contact_email: email,
    } = this.props.techContact;

    return name || phone || email ? (
      <div className="technical-contact p-20">
        <p className="m-b-10">{i18n.t('Please email or call your technical contact if this error persists')}</p>
        {name && <strong className="m-r-15">{name}</strong>}
        {phone && <span className="m-r-15">{phone}</span>}
        {email && <a href={sanitizeUrl(`mailto:${email}`)}>{email}</a>}
      </div>
    ) : null;
  };

  renderBackButton = () => {
    const { backButtonUrl, backButtonText } = this.props;

    return backButtonUrl ? (
      <Button
        label={backButtonText || i18n.t('Back to Learner Dashboard')}
        icon="angle-left"
        style="primary"
        className="btn-back"
        href={backButtonUrl}
      />
    ) : null;
  };

  get imageUrl() {
    let imageUrl = '';
    switch (this.props.type) {
      case 'general_error':
        imageUrl = GeneralErrorImg;
        break;
      case 'not_found':
        imageUrl = NotFoundImg;
        break;
      case 'no_access':
        imageUrl = NoAccessImg;
        break;
      case 'maintenance':
        imageUrl = MaintenanceImg;
        break;
      default:
        imageUrl = GeneralErrorImg;
    }

    return imageUrl;
  }

  render() {
    return (
      <div className="error-page-container">
        <h2>{this.props.title}</h2>
        {this.props.errors && this.renderErrorMessages()}
        <img src={this.imageUrl} alt={i18n.t('Error')} className="img-error img-fluid" />
        {this.renderTechnicalContact()}
        {this.renderBackButton()}
      </div>
    );
  }
}
